import { createElementBlock as a, openBlock as n, normalizeClass as r, createElementVNode as c, createCommentVNode as i, createBlock as d, toDisplayString as l } from "vue";
import m from "../link/link.vue.js";
import { themeProp as s } from "../../composables/useTheme.js";
const u = {
  class: "ds-heading",
  "data-j-title": ""
}, k = {
  key: 0,
  class: "ds-text ds-margin-top-12",
  "data-j-text": ""
}, o = "DsIntroText", h = /* @__PURE__ */ Object.assign({
  name: o
}, {
  __name: "intro-text",
  props: {
    ...s,
    title: {
      type: String,
      required: !0
    },
    text: {
      type: String,
      default: ""
    },
    link: {
      type: Object,
      default: null,
      validator: (t) => ["title", "url", "openInNewWindow", "nuxt"].every((e) => e in t)
    },
    alignCenter: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    return (e, g) => (n(), a("div", {
      class: r([{ "ds-color-white": e.theme === "dark" }, { "ds-text-align-center": t.alignCenter }]),
      "data-j-container": ""
    }, [
      c("h2", u, l(t.title), 1),
      t.text ? (n(), a("p", k, l(t.text), 1)) : i("", !0),
      t.link ? (n(), d(m, {
        key: 1,
        "tracking-data": { "component-name": o, text: t.link.title, title: t.title },
        url: t.link.url,
        "lazy-url-endpoint": t.link.lazyUrlEndpoint,
        "open-in-new-window": t.link.openInNewWindow,
        nuxt: t.link.nuxt,
        content: t.link.title,
        "icon-right": { category: "arrows", name: "chevron-right-small" },
        class: "ds-margin-top-24",
        "data-j-link": ""
      }, null, 8, ["tracking-data", "url", "lazy-url-endpoint", "open-in-new-window", "nuxt", "content"])) : i("", !0)
    ], 2));
  }
});
export {
  h as default
};
